import Api from "../../../lib/api";
import EventEmitter from "../../../components/base/event-emitter";
import ModalForm from "../../../components/base/forms/modal-form";

export default class CertificateDashboard extends EventEmitter {
	constructor(data) {
		super();
		this.$root = document.getElementById('certificateDashboard');
		this.$eventTarget = this.$root; // For event emitter purposes
		this.$langSwitcher = document.getElementById('certificateLangSwitcher');
		this.$enSwitcher = this.$langSwitcher.querySelector('[data-lang-switcher="en"]');
		this.$ukSwitcher = this.$langSwitcher.querySelector('[data-lang-switcher="uk"]');
		this.$pngLink = document.getElementById('certificatePng');
		this.$pdfLink = document.getElementById('certificatePdf');
		this.$imageContainer = document.getElementById('certificateImageContainer');
		this.$info = document.getElementById('certificateInfo');
		this.$graduation = document.getElementById('certificateInfoGraduation');
		this.$homework = document.getElementById('certificateInfoHomework');
		this.$average = document.getElementById('certificateInfoAverage');
		this.$english = document.getElementById('certificateInfoEnglish');

		this.data = data;

		this.certificateNum = null;

		this.cityId = 'online';
		this.en = null;
		this.uk = null;
		this.langCount = null;
		this.courseId = null;
		this.grade = null;
		this.homework = null;
		this.average = null;
		this.english = null;
		this.hidden = false;
		this.is_video_course = false;

		this.imgLoaded = false;
		this.courseDataFetched = false;

		this.DASHBOARD_INIT_COMPLETE = 'dashboardInitComplete';

		this.init();
	}

	init() {
		if (!this.data) {
			return;
		}

		this.parseData();
		this.fetchCourse();
		this.setElementsData();
		this.initCoachFeedbackForm();
		this.addEventListeners();
	}

	addEventListeners() {
		if (this.en) {
			this.$enSwitcher.addEventListener('click', () => {
				this.setActiveSwitcher('en');
			});
		}

		if (this.uk) {
			this.$ukSwitcher.addEventListener('click', () => {
				this.setActiveSwitcher('uk');
			});
		}
	}

	parseData() {
		if (this.data.refNo) {
			this.certificateNum = this.data.refNo;
		}

		this.grade = this.data.grade;

		if (this.data.group) {
			if (this.data.group.course && this.data.group.course._id) {
				this.courseId = this.data.group.course._id;
			}
		}

		if (this.data['pdf_en']) {
			this.setLangData('en');
		}

		if (this.data['pdf_uk']) {
			this.setLangData('uk');
		}

		if (this.data.rating) {
			if (this.data.rating.homeworks) {
				const { did, total } = this.data.rating.homeworks;
				this.homework = Math.floor(100 * did / total);
			}

			if (this.data.rating.point) {
				this.average = this.data.rating.point;
			}
		}

		if (this.data.user && this.data.user.english) {
			this.english = this.data.user.english;
		}

		this.hidden = this.data.hidden;

		if (this.data.type) {
			this.is_video_course = this.data.type === 'max';
		}
	}

	fetchCourse() {
		if (!this.courseId) {
			this.courseDataFetched = true;
			return;
		}

		const params = {
			scheduleId: this.courseId
		};
		const cityId = this.cityId || costorage.get('h_city');

		if (cityId) {
			params.cityId = cityId;
		}

		Api.get(`${craft.env.apiSiteUrl}/feed/certificateCourse`, params)
			.then((data) => {
				if (data) {
					const courseBar = data.trim();

					if (courseBar) {
						this.$info.insertAdjacentHTML('afterbegin', courseBar);
					}
				}

				if (this.imgLoaded) {
					this.dispatchEvent(this.DASHBOARD_INIT_COMPLETE);
				}
				this.courseDataFetched = true;
			});
	}

	setElementsData() {
		this.setGrade();
		this.setLangSwitcher();
		this.setCurrentLanguageDefaults();

		if (!this.hidden) {
			this.setHomework();
			this.setAverage();
			// this.setEnglish();
		}

		this.setCoachFeedback();
	}

	setCurrentLanguageDefaults() {
		if (this.en) {
			this.setLanguageData('en');
		} else if (this.uk) {
			this.setLanguageData('uk');
		}
	}

	setLanguageData(lang) {
		if (!this[lang]) {
			return;
		}

		this.setCertificateImg(this[lang].png);
		this.$pngLink.href = this[lang].png;
		this.$pdfLink.href = this[lang].pdf;
	}

	setGrade() {
		if (this.grade) {
			const $el = this.$graduation.querySelector(`[data-value="${this.grade}"]`);

			if ($el) {
				$el.classList.add('-active');
			}

			this.$graduation.classList.remove('-hidden');
		} else {
			this.$graduation.classList.add('-hidden');
		}
	}

	setLangSwitcher() {
		if (!this.en) {
			this.$enSwitcher.classList.add('-hidden');
		}

		if (!this.uk) {
			this.$ukSwitcher.classList.add('-hidden');
		}

		if (this.langCount < 2) {
			this.$langSwitcher.classList.add('-hidden');
		}
	}

	setActiveSwitcher(lang) {
		this.$enSwitcher.classList.remove('-active');
		this.$ukSwitcher.classList.remove('-active');

		const $newActive = this.$langSwitcher.querySelector(`[data-lang-switcher="${lang}"]`);
		if ($newActive) {
			$newActive.classList.add('-active');
			this.setLanguageData(lang);
		}
	}

	setCertificateImg(src) {
		const img = new Image();
		img.src = src;
		img.alt = 'Certificate';

		img.onload = () => {
			this.$imageContainer.innerHTML = '';
			this.$imageContainer.append(img);

			if (this.courseDataFetched && !this.imgLoaded) {
				this.dispatchEvent(this.DASHBOARD_INIT_COMPLETE);
			}
			this.imgLoaded = true;
		};
	}

	setHomework() {
		if (!this.homework) {
			return;
		}

		const $el = this.$homework.querySelector('.certificate-info-bar_value');
		$el.textContent = this.homework;
		this.$homework.classList.remove('-hidden');
	}

	setAverage() {
		if (!this.average) {
			return;
		}

		const $el = this.$average.querySelector('.certificate-info-bar_value');
		$el.textContent = this.average;
		this.$average.classList.remove('-hidden');
	}

	setEnglish() {
		if (!this.english) {
			return;
		}

		const $el = this.$english.querySelector('.certificate-info-bar_text');
		$el.textContent = this.english;
		this.$english.classList.remove('-hidden');
	}

	setLangData(lang) {
		if (!lang) return;

		this[lang] = {
			pdf: this.data['pdf_' + lang],
			png: this.data['png_' + lang]
		}
		this.langCount++;
	}

	initCoachFeedbackForm() {
		try	{
			if (!this.is_video_course) {
				this.coachFeedbackForm = new ModalForm({
					formId: 'coach-feedback',
					uri: '/1.0/certificate/review',
					data: {
						fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
						fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
						referrer: location.href,
						certificate: this.certificateNum
					},
					$modalTriggers: Array.from(document.querySelectorAll('[data-modal-trigger="coach-feedback"]'))
				});
			}
		} catch (err) {
			console.error('CoachFeedback Form:', err);
		}
	}

	setCoachFeedback() {
		const $el = this.$root.querySelector('.certificate-dashboard-header_feedback');

		if ($el) {
			if (this.is_video_course) {
				$el.classList.add('-hidden');
			} else {
				$el.classList.remove('-hidden');
			}
		}
	}
}